module.exports = __webpack_public_path__ + "static/media/print.2314a518.png";